<div class="date-filter-input-wrap">
    <input
        class="form-control"
        placeholder="Month Day, Year - Month Day, Year"
        [formControl]="inputControl"
        [nbDatepicker]="dateRangePicker"
        readonly
    />
    <div class="calendar-icon">
        <nb-icon nbSuffix icon="calendar-outline"></nb-icon>
    </div>
    <nb-rangepicker #dateRangePicker (rangeChange)="dateRangeChange($event)"></nb-rangepicker>

    <div *ngIf="inputControl.value" class="clear-date-icon">
        <nb-icon (click)="clearDateFilterInput()" icon="close" status="basic"></nb-icon>
    </div>
</div>
